export default __webpack_public_path__ + "static/media/table-view.95fc946d.svg";